import {
  Text,
  TokenTextAppearance,
  styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { CustomTooltipData } from './CustomTooltipData';

const ToolTipContainer = styled.div`
  background-color: #dfe4e8;
  padding: 0.5rem;
`;

const ToolTips = styled.ul`
  display: flex;
  flex-direction: column-reverse;
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 0;
    margin: 0;
  }
`;

const TooltipYearContainer = styled.div`
  padding: 0 2px;
`;

const CustomTooltip = (props: any) => {
  const {active, label, payload} = props;

  const payloadSorted = payload.sort((p: any, p2: any) =>
    p.value > p2.value ? 1 : -1,
  );

  if (active && payloadSorted?.length) {
    return (
      <ToolTipContainer role="status" aria-live="assertive">
        <TooltipYearContainer>
          <Text appearance={TokenTextAppearance.headline100} bold>
            {label}
          </Text>
        </TooltipYearContainer>
        <ToolTips>
          <CustomTooltipData
            payloadSorted={payloadSorted}
            language={props.language}
          />
        </ToolTips>
      </ToolTipContainer>
    );
  }

  return null;
};

export default CustomTooltip;
